import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ThemeService } from '../theme-service/theme.service';

@Component({
  selector: 'app-modal-sucess',
  templateUrl: './modal-sucess.component.html',
  styleUrls: ['./modal-sucess.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class ModalSucessComponent implements OnInit {


	public primaryColor: any;
	public title: string;
	public topText: string;
	public text: string;
	public description: string;
	public backButton: string;
	public confirmButton: string;
	public fecharModalAutomaticamente: boolean;

	constructor(
		public dialogRef: MatDialogRef<ModalSucessComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private themeService: ThemeService
	) {
		this.title = data.title ? data.title : '';
		this.text = data.text ? data.text : '';
		this.topText = data.topText ? data.topText : '';
		this.description = data.description ? data.description : '';
		this.backButton = data.backButton ? data.backButton : '';
		this.confirmButton = data.confirmButton ? data.confirmButton : '';
		this.fecharModalAutomaticamente = data.fecharModalAutomaticamente;
	}

	ngOnInit(): void {
		if (this.themeService.themeConfigs) {
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}

		if(this.fecharModalAutomaticamente){
			setTimeout(()=>{this.dialogRef.close()}, 1000);
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-sucess/modal-sucess.component.ts